import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const applicantApi = axios.create({ baseURL: API });

applicantApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("ca_applicant_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

applicantApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("ca_applicant_token");
    }
    return Promise.reject(err);
  }
);

export { API };
export default applicantApi;
